import { clsx } from 'clsx';
import { Typography } from '../typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { chip, chipDisabled, chipIcon, chipSelected, events } from './chip.css';
import { forwardRef, ReactNode } from 'react';

export type ChipProps = {
  label: string | ReactNode;
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  startIcon?: IconProp;
  endIcon?: IconProp;
  onClick?: () => void;
  readonly?: boolean;
};

export const Chip = forwardRef<HTMLDivElement, ChipProps>((p, ref) => (
  <div
    className={clsx(
      chip,
      p?.readonly && 'pointer-events-none',
      p?.disabled && chipDisabled,
      p?.selected && chipSelected,
      p.className,
    )}
    onClick={() => p?.onClick && p.onClick()}
    data-testid="chip"
    ref={ref}
  >
    {p?.startIcon ? (
      <FontAwesomeIcon icon={p.startIcon} className={clsx(chipIcon, events)} />
    ) : null}
    <Typography variant="body" size="medium" as="span" className={events}>
      {p.label}
    </Typography>
    {p?.endIcon ? (
      <FontAwesomeIcon icon={p.endIcon} className={clsx(chipIcon, events)} />
    ) : null}
  </div>
));
